export const MARKETING_NAV_CDN_QA_URL = 'https://www.hubspot.com/assets/nav/next/index.js';
export const MARKETING_NAV_CDN_PROD_URL = 'https://www.hubspot.com/assets/nav/latest/index.js';
export const MARKETING_NAV_CDN_SCRIPT_ID = 'marketing-nav-script';
export const MARKETING_NAV_HEADER_ID = 'marketing-nav-header';
export const MARKETING_NAV_FOOTER_ID = 'marketing-nav-footer';